import { useState } from 'react';
import arrow from '@assets/arrow.svg';
import './index.scss';

export default function Index({ children, col = "two" }: {
    children: any,
    col?: 'one' | "two"
}) {


    const [hidden, setHidden] = useState(false)

    return <div className={`card-line ${col} ${hidden && 'hidden'}`}>
        {col == "one" && <img onClick={() => {
            setHidden(!hidden)
        }} className={`arrow  ${hidden && "hidden"}`} src={arrow} />}
        {children}
    </div>
}